import React from 'react'
import styled from 'styled-components'
import HealthierChoiceIllustration from '../../components/icons/svg/healthier-choice-illustration.svg'
import { getConfigFor } from '../../utils/configService'
import { SPLIT_FEATURES } from '../../utils/constants'

const Container = styled.div``

const ImageBackground = styled.div`
  background: #f2f2f2;
  height: 10.125rem;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1rem;
`

const Description = styled.div`
  font-size: 0.875rem;
  margin-top: 0.5rem;
  font-weight: 400;
  line-height: 1.25rem;
  margin-bottom: 0.5rem;
`

const Link = styled.a`
  color: #1454b8;
  font-size: 0.875rem;
  margin-top: 0.5rem;
  font-weight: 700;
  line-height: 1.25rem;
  text-decoration: none;
`

const getSplitConfig = () => {
  try {
    const { raw } = getConfigFor(SPLIT_FEATURES.HEALTHIER_CHOICE_INFO_ENABLED)
    return JSON.parse(raw?.config)
  } catch (e) {
    return null
  }
}

const HealthierChoiceInfoSheetBody = ({ onLinkClick }) => {
  const splitConfig = getSplitConfig()

  return (
    <Container>
      <ImageBackground>
        <img src={HealthierChoiceIllustration} />
      </ImageBackground>
      <Description>
        Buy Healthier Choice items and earn Healthpoints on the Healthy 365 app
        to redeem FairPrice vouchers! To qualify, link accounts via the Healthy
        365 app and join HPB’s Eat, Drink, Shop Healthy Challenge.
      </Description>
      {splitConfig?.faqLink && splitConfig?.faqText && (
        <div>
          <Link
            onClick={() => {
              onLinkClick()
            }}
            target="_blank"
            rel="noopener noreferrer"
            href={splitConfig.faqLink}
          >
            {splitConfig.faqText}
          </Link>
        </div>
      )}
    </Container>
  )
}

export default HealthierChoiceInfoSheetBody
